import Api from "../services/Api";



export const getBacthData = async (userData) => {

    var res = {
      status: null
    }


    try {
      const response = await Api.post('/batch/data/all', userData);

      // console.log('response', response);
      res.status = "valid";
      res.batchData = response;

      return res;

    } catch (error) {

      res.status = "error";
      // console.log(error);
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const addBacthData = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/batch/data/addMany', userData);

      console.log('response', response);
      res.status = "valid";

      res = {...res,...response};

      
      return res;

    } catch (error) {

      res.status = "error";
      // console.log(error);
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const addBacth = async (userData) => {

    var res = {
      status: null
    }

    // const authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmMzE1ODVhYjAwNDA5MDkwOGFjNjY1NSIsImlhdCI6MTU5ODY2ODI5OSwiZXhwIjoxNTk4OTI3NDk5fQ.u-BC6fLLBtB_FKTePdlKXv5ij37yVV8cm_crWMucOdI";

    try {
      const response = await Api.post('/batch/data/addOne', userData);

      console.log('response', response);
      res.status = "valid";

      res = {...res,...response};

      
      return res;

    } catch (error) {

      res.status = "error";
      // console.log(error);
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const getBatch = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/batch/data/getOne', userData);

      // console.log('response', response);
      res.status = "valid";

      res = {...res,...response};

      
      return res;

    } catch (error) {

      res.status = "error";
      console.log(error);
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const updateBatch = async (userData) =>{

     var res = {
      status: null
    }

    try {
      const response = await Api.post('/batch/data/updateOne', userData);

      console.log('response', response);
      res.status = "valid";

      res = {...res,...response};

      
      return res;

    } catch (error) {

      res.status = "error";
      console.log(error);
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
}
